import { createSlice } from "@reduxjs/toolkit";
import { viewDonate, registerDonate } from "../actions/donateAction";

const orderSlice = createSlice({
  name: "donate",
  initialState: {
    donate: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(viewDonate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewDonate.fulfilled, (state, action) => {
        state.loading = false;
        state.donate = action.payload;
      })
      .addCase(viewDonate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(registerDonate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerDonate.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.donate = action.payload;
      })
      .addCase(registerDonate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default orderSlice.reducer;
